export const sourceOptions = [
  { value: "WEBSITE", title: "Website" },
  { value: "CAREER_BUILDER", title: "Career Builder" },
  { value: "DICE", title: "Dice" },
  { value: "GLASS_DOOR", title: "Glass Door" },
  { value: "INDEED", title: "Indeed" },
  { value: "LINKEDIN", title: "LinkedIn" },
  { value: "MONSTER", title: "Monster" },
  { value: "STACK_OVERFLOW", title: "Stack Overflow" },
  { value: "ZIPRECRUITER", title: "Ziprecruiter" },
  { value: "INTERNAL", title: "Internal" },
  { value: "EMAIL_MARKETING", title: "Email Marketing" },
];

export const SOURCE_VALUES = sourceOptions.map((option) => option.value);
